import { useLocalization } from "@fluent/react";

import styles from "../AccountsModule.module.scss";

import type { ViewMode } from "../useViewPreference";

type ViewToggleProps = {
  view: ViewMode;
  onChange: (mode: ViewMode) => void;
};

const ViewToggle = ({ view, onChange }: ViewToggleProps) => {
  const { l10n } = useLocalization();
  const nextView = view === "card" ? "list" : "card";
  return (
    <button
      type="button"
      className={`${styles.viewToggle} ${
        view === "list" ? styles.viewToggleListActive : ""
      }`}
      onClick={() => onChange(nextView)}
      aria-label={l10n.getString(
        nextView === "card"
          ? "accounts-view-toggle-card"
          : "accounts-view-toggle-list"
      )}
    >
      <span
        className={`${styles.viewToggleIcon} ${styles.viewToggleAnchorCard} ${
          view === "card" ? styles.viewToggleIconActive : ""
        }`}
      >
        <span className="narmi-icon-grid" />
      </span>
      <span
        className={`${styles.viewToggleIcon} ${styles.viewToggleAnchorList} ${
          view === "list" ? styles.viewToggleIconActive : ""
        }`}
      >
        <span className="narmi-icon-menu" />
      </span>
    </button>
  );
};

export default ViewToggle;
